// Import model
import { UpdateExternalLinkRequest } from '../models/UpdateExternalLinkRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateSfExternalLinkRequest } from '../models/UpdateSfExternalLinkRequest';

// Import dependency serializers (for complex types)
import { UpdateSfExternalLinkRequestSerializer } from './UpdateSfExternalLinkRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateExternalLinkRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateExternalLinkRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateExternalLinkRequest instance
   */
  static deserialize(json: string): UpdateExternalLinkRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateExternalLinkRequest instance
   */
  static fromObject(obj: any): UpdateExternalLinkRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateExternalLinkRequest');
    }


    const instance: UpdateExternalLinkRequest = {
      properties: obj['Properties'] ? UpdateSfExternalLinkRequestSerializer.fromObject(obj['Properties']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateExternalLinkRequest instances
   */
  static deserializeArray(json: string): UpdateExternalLinkRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateExternalLinkRequest instance to a JSON string
   */
  static serialize(instance: UpdateExternalLinkRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateExternalLinkRequest instance to a plain object
   */
  static toObject(instance: UpdateExternalLinkRequest): any {
    return {
      'Properties': instance.properties ? UpdateSfExternalLinkRequestSerializer.toObject(instance.properties) : undefined,
    };
  }

  /**
   * Serializes an array of UpdateExternalLinkRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateExternalLinkRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
